export enum AbTests {
  SkipLandingPage = 'SkipLandingPage',
}
